<template>
  <pc-dialog title="选择角色" :visible.sync="dialogVisible" @close="close" @confirm="handleBind">
    <template #content>
      <form class="form">
        <div class="form__item required">
          <label class="form__label" for="serverId">
            <span>服务器</span>
            <span>：</span>
          </label>
          <select id="serverId" v-model="form.server_id" @change="selectServer">
            <option
              v-for="(item, key) in roleList"
              :key="key"
              :value="item.serverId"
            >{{ item.serverName }}</option>
          </select>
        </div>
        <div class="form__item required">
          <label class="form__label" for="role">
            <span>角色</span>
            <span>：</span>
          </label>
          <input id="role" type="text" v-model="form.role_name" autocomplete="off" readonly />
        </div>
      </form>
    </template>
  </pc-dialog>
</template>

<script>
import PcDialog from '../dialog/Index.vue'

import bindDialogMixins from '@/mixins/bindDialogMixins.js'

export default {
  name: 'PcBindDialog',
  mixins: [bindDialogMixins],
  components: {
    PcDialog,
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/pc/form.scss';
</style>